import { Component, ReactNode } from "react";

import { SomethingWentWrong } from "./";

interface Props {
  children?: ReactNode;
  hasAppError: boolean;
  setHasAppError: (hasAppError: boolean) => void;
}

class ErrorBoundary extends Component<Props, { error: any }> {
  public componentDidCatch() {
    this.props.setHasAppError(true);
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  static getDerivedStateFromError() {}

  render() {
    if (this.props.hasAppError) {
      return <SomethingWentWrong />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
